import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Tool from '../tool';
import { getDep } from '../../../dependency-manager';
import { TRACKER_FILL, polyPathToPath } from '../../../lib';
import { priorityList } from '../../../schedular';
var R = getDep('redraphael', 'plugin'),
    START = 'start';

var ScrollButtons =
/*#__PURE__*/
function (_Tool) {
  _inherits(ScrollButtons, _Tool);

  function ScrollButtons() {
    var _this;

    _classCallCheck(this, ScrollButtons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollButtons).call(this)), _this._evtHandlers = {};
    return _this;
  }

  _createClass(ScrollButtons, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = this.config,
          d = b.getLinkedParent().config;
      c.type = a.type, c.buttonFill = a.buttonFill, c.buttonStroke = a.buttonStroke, c.arrowFillColor = a.buttonPointerFill || R.tintshade(d.color, -.4).rgba;
    }
  }, {
    key: "attachEventHandlers",
    value: function attachEventHandlers() {
      var a,
          b,
          c = this,
          d = c.config,
          e = c.getLinkedParent(),
          f = e.config,
          g = e.getChildren('scrollAnchor')[0],
          h = function h() {
        1 <= f.scrollPosition ? f.scrollPosition = 1 : (0 >= f.scrollPosition || isNaN(f.scrollPosition)) && (f.scrollPosition = 0), g.asyncDraw(), 'function' == typeof f.evt.scroll && f.evt.scroll(f.scrollPosition);
      },
          i = function i() {
        b = !0, d.type === START ? f.scrollPosition -= .01 : f.scrollPosition += .01, h(), c.addJob('dragScrollAnchor', i, priorityList.draw);
      };

      c.addEventListener('fc-mousedown', c._evtHandlers.mousedown || (c._evtHandlers.mousedown = function () {
        a = setTimeout(function () {
          c.addJob('dragScrollAnchor', i, priorityList.draw);
        }, 300);
      })), c.addEventListener('fc-mouseup', c._evtHandlers.mouseup || (c._evtHandlers.mouseup = function () {
        clearTimeout(a), c.removeJob('dragScrollAnchor'), b || (d.type === START ? f.scrollPosition -= .1 : f.scrollPosition += .1, h()), b = !1;
      })), c.addEventListener('fc-mouseout', function () {
        b && c._evtHandlers.mouseup();
      });
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = Math.min;
      var b = this,
          c = b.config,
          d = this.getLinkedParent(),
          e = d.config,
          f = {
        id: 'scrollerGroup',
        label: 'scrollerGroup',
        isParent: !0
      },
          g = e.isHorizontal,
          h = e.x + .5,
          i = e.y + e.padding + .5,
          j = e.width - 1,
          k = 1 > e.height - 1 ? 1 : e.height - 1,
          l = g ? a(k, .5 * j) : a(j, .5 * k),
          m = g ? polyPathToPath([3, h + .5 * l, i + .5 * k, .25 * l, 180]) : polyPathToPath([3, h + .5 * j, i + .5 * l, .25 * l, 90]),
          n = g ? polyPathToPath([3, h + j - .5 * l, i + .5 * l, .25 * l, 0]) : polyPathToPath([3, h + .5 * j, i + k - .5 * l, .25 * l, -90]);
      b.addGraphicalElement({
        el: 'rect',
        attr: {
          x: 'start' === c.type ? h : g ? h + j - l : h,
          y: 'start' === c.type ? i : g ? i : i + k - l,
          width: 'start' === c.type ? g ? l : j : g ? l : j,
          height: 'start' === c.type ? g ? k : l : g ? k : l,
          fill: c.buttonFill || TRACKER_FILL,
          stroke: c.buttonStroke || 'none'
        },
        container: f,
        component: b,
        label: 'scroller' + c.type + 'ButtonRect',
        id: 'scroller' + c.type + 'ButtonRect'
      }), b.addGraphicalElement({
        el: 'path',
        attr: {
          path: 'start' === c.type ? m : n,
          fill: c.arrowFillColor,
          stroke: 'none'
        },
        container: f,
        component: b,
        label: 'scroller' + c.type + 'ButtonPath',
        id: 'scroller' + c.type + 'ButtonPath'
      });
    }
  }]);

  return ScrollButtons;
}(Tool);

export default ScrollButtons;